const parseLocalDate = (value: string | Date): Date | null => {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  const dateOnly = value.trim().split(/[\sT]/)[0];
  if (/^\d{4}-\d{2}-\d{2}$/.test(dateOnly)) {
    const [year, month, day] = dateOnly.split('-').map(Number);
    return new Date(year, month - 1, day);
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

/**
 * Compute trip length from embark / disembark calendar dates.
 * Example: 10 Jun → 14 Jun ⇒ 5 days / 4 nights.
 */
export const computeTripDuration = (
  embarkationDate: string | Date | undefined | null,
  disembarkationDate: string | Date | undefined | null,
): { days: number; nights: number } | null => {
  if (!embarkationDate || !disembarkationDate) {
    return null;
  }

  const embark = parseLocalDate(embarkationDate);
  const disembark = parseLocalDate(disembarkationDate);
  if (!embark || !disembark) {
    return null;
  }

  const msPerDay = 1000 * 3600 * 24;
  const embarkUtc = Date.UTC(
    embark.getFullYear(),
    embark.getMonth(),
    embark.getDate(),
  );
  const disembarkUtc = Date.UTC(
    disembark.getFullYear(),
    disembark.getMonth(),
    disembark.getDate(),
  );
  const nights = Math.round((disembarkUtc - embarkUtc) / msPerDay);

  if (nights < 0) {
    return null;
  }

  return {
    days: nights + 1,
    nights,
  };
};
